import React from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

export interface RemarkPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  title?: string;
  content: string;
  onClose: () => void;
  maxWidth?: number;
}

const RemarkPopover: React.FC<RemarkPopoverProps> = ({
  anchorEl,
  open,
  title = 'Remark',
  content,
  onClose,
  maxWidth = 360,
}) => (
  <Popover
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    slotProps={{
      paper: {
        sx: {
          maxWidth,
          borderRadius: 2,
          boxShadow: 4,
          p: 0,
        },
      },
    }}
  >
    <Box
      sx={{
        px: 1.5,
        py: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'grey.50',
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <IconButton size="small" onClick={onClose} aria-label="close remark">
        <CloseOutlinedIcon fontSize="small" />
      </IconButton>
    </Box>
    <Box sx={{ px: 1.5, py: 1.25, maxHeight: 200, overflowY: 'auto' }}>
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'pre-wrap',
          color: 'text.secondary',
          lineHeight: 1.6,
        }}
      >
        {content || '-'}
      </Typography>
    </Box>
  </Popover>
);

export default RemarkPopover;
